import { render } from "./ArchivalVehicleData.vue?vue&type=template&id=2b8174d4&scoped=true"
import script from "./ArchivalVehicleData.vue?vue&type=script&lang=js"
export * from "./ArchivalVehicleData.vue?vue&type=script&lang=js"

import "./ArchivalVehicleData.vue?vue&type=style&index=0&id=2b8174d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b8174d4"]])

export default __exports__